var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7722 14.0559L16.0381 14.322C16.2951 14.5801 16.6378 14.7222 17.0027 14.7222C17.3675 14.7222 17.7102 14.5801 17.9668 14.3225L21.6028 10.6842C21.8606 10.427 22.0027 10.0841 22.0027 9.71897C22.0027 9.35385 21.8606 9.01094 21.6032 8.75419L21.3368 8.48769C21.1593 8.31003 20.8716 8.31003 20.6941 8.48769L15.7722 13.4128C15.5946 13.5904 15.5946 13.8782 15.7722 14.0559Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9416 8.22108C10.0304 8.30993 10.1467 8.35433 10.263 8.35433C10.3793 8.35433 10.4956 8.30993 10.5844 8.22108L15.5063 3.29596C15.6838 3.1183 15.6838 2.83044 15.5063 2.65279L15.2404 2.38671C14.7263 1.87057 13.8248 1.871 13.3117 2.38628L9.67569 6.02455C9.41779 6.28173 9.27576 6.62464 9.27576 6.98975C9.27576 7.35487 9.41779 7.69778 9.67526 7.95453L9.9416 8.22108Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4863 12.7695C14.5751 12.8584 14.6914 12.9028 14.8077 12.9028C14.924 12.9028 15.0403 12.8584 15.1291 12.7695L20.051 7.8444C20.2286 7.66674 20.2286 7.37888 20.051 7.20123L16.7911 3.9391C16.6135 3.76145 16.3259 3.76145 16.1483 3.9391L11.2264 8.86423C11.0489 9.04188 11.0489 9.32974 11.2264 9.5074L11.88 10.1614C8.36007 13.2135 3.83599 17.5921 2.53499 18.894C2.1914 19.2378 2.00232 19.6944 2.00232 20.1803C2.00232 21.1837 2.81773 21.9997 3.82052 21.9997C4.30614 21.9997 4.76245 21.8105 5.10605 21.4667C6.67214 19.8995 10.9414 15.4755 13.8437 12.1264L14.4863 12.7695Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2749 17.4543H12.9112C11.4073 17.4543 10.184 18.6644 10.184 20.1684C10.184 21.1711 10.9994 21.9866 12.0022 21.9866H20.184C21.1867 21.9866 22.0022 21.1712 22.0022 20.1684C22.0021 18.6644 20.7788 17.4543 19.2749 17.4543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.19158438dc39eda3f9a1977f367e8d48.svg";
export { ForwardRef as ReactComponent };